/*
  this map.js file originally done by HTML Burger
*/
import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import MapMarker from './map-marker';
import { Container } from 'react-bootstrap';
import classNames from 'classnames';

/**
 * Assets
 */
import './assets/styles/_index.scss';

const locations = {
  location: [
    {
      lat: 47.246249,
      lng: -120.769519,
      html: "Some text"
    }
  ],
  schools: [
    {
      lat: 47.316249,
      lng: -120.719519,
      html: "Some text"
    },
    {
      lat: 47.343249,
      lng: -120.769519,
      html: "Some text"
    }
  ],
  local: [
    {
      lat: 47.246249,
      lng: -120.669519,
      html: "Some text"
    }
  ]
}

const Map = (props) => {
  const className = props.className || "";
  const [activeCTA, setActiveCTA] = useState('location');
  const [defaultProps, setDefaultProps] = useState({
    center: {
      lat: 47.244249,
      lng: -120.669519,
    },
    markers: [{
      lat: 47.246249,
      lng: -120.769519,
      html: "Some text"
    }],
    zoom: 11
  });
  
  const handleClick = (event, name) => {
    event.preventDefault();
    setActiveCTA(name);
    setDefaultProps({
      ...defaultProps,
      markers: [...locations[name]]
    })
  }

  return (
    <div id="map-holder" className={classNames('map', className)}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyC5mhwsc0pN7XV9Q4uKvu2C09viTFx0RC8' }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
      >
        {defaultProps.markers.map((marker,ind) => <MapMarker key={ind} lat={marker.lat} lng={marker.lng} html={marker.html} />)}
      </GoogleMapReact>
      <div className="cta">
        <Container>
          <a href="/" className={classNames({'is-active': activeCTA === 'location'})} onClick={(event) => handleClick(event, 'location')}>Location</a>
          <a href="/" className={classNames({'is-active': activeCTA === 'schools'})} onClick={(event) => handleClick(event, 'schools')}>Schools</a>
          <a href="/" className={classNames({'is-active': activeCTA === 'local'})} onClick={(event) => handleClick(event, 'local')}>Local info</a>
        </Container>
      </div>
    </div>
  )
}

export default Map;